import React, { useEffect } from 'react';
import { Alert, Button } from 'reactstrap';
import Helmet from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import { useSession } from '@cordata/buffet';

import { Splash } from '~/components';

const DeviceAuthentication = () => {
  const { state } = useLocation();
  const history = useHistory();
  const { registerAuthDevice, loginWithDevice } = useSession();

  const registerDevice = () => {
    registerAuthDevice(state)
      .then(() => {
        history.push('/login', {
          deviceAuthStatus: {
            result: 'success',
            message: 'Successfully registered auth device.',
          },
        });
      })
      .catch(() => {
        history.push('/login', {
          deviceAuthStatus: {
            result: 'error',
            message: 'Failed to register authentication device.',
          },
        });
      });
  };

  const login = () => {
    loginWithDevice(state)
      .then(() => history.push('/home'))
      .catch(() => {
        history.push('/login', {
          deviceAuthStatus: {
            result: 'error',
            message: 'Failed to authenticate with device',
          },
        });
      });
  };

  useEffect(() => {
    if (state.deviceIsRegistered) {
      login();
    }
  }, [state.deviceIsRegistered]);

  return (
    <Splash>
      <Helmet title="Device Authentication" />
      { state.deviceIsRegistered ? (
        <>
          <Alert color="info">
            <i>Insert your authentication device and touch the button</i>
          </Alert>
        </>
        ) : (
        <>
          <Alert color="info">
            <i>No authentication device found for this user. Please register one now.</i>
          </Alert>
          <Button
            onClick={registerDevice}
            block
          >Register Device
          </Button>
        </>
        )
      }
    </Splash>
  );
};

export default DeviceAuthentication;
